import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export function getCountryFlagEmoji(countryCode: UserCountryCode): string {
  switch (countryCode) {
    case UserCountryCodes.IT:
      return '🇮🇹';
    case UserCountryCodes.ES:
      return '🇪🇸';
    case UserCountryCodes.DE:
      return '🇩🇪';
  }
}
